import { combine, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

const timeClockStore = combine({ timeClock: null }, set => ({
  addTimeClockDetails: (timeClockDetails: any) => set(() => ({ timeClock: timeClockDetails })),
}));

export const useTimeClockStore = create(persist(timeClockStore, { name: 'timeClock' }));
